import { Linking } from "react-native";

const MONEYGRAM_TERMS_AND_CONDITIONS_URL =
  "https://www.moneygram.com/us/en/help-center/terms-and-conditions";
const MONEYGRAM_PRIVACY_POLICY_URL =
  "https://www.moneygram.com/intl/privacy-center/us-privacy-notice";
const MONEYGRAM_TERMS_OF_USE_URL =
  "https://www.moneygram.com/us/en/help-center/terms-of-use";

/** US terms — Spanish (MoneyGram help center) */
const MONEYGRAM_TERMS_AND_CONDITIONS_US_ES_URL =
  "https://www.moneygram.com/us/es/help-center/terms-and-conditions";
/** US privacy notice — Spanish (MoneyGram privacy center) */
const MONEYGRAM_PRIVACY_POLICY_US_ES_URL =
  "https://www.moneygram.com/intl/privacy-center/aviso-de-privacidad-de-ee-uu";

function openUrl(url: string): void {
  void Linking.openURL(url).catch(() => {
    // Opening the browser can fail in kiosk/offline contexts; ignore.
  });
}

export function openMoneygramTermsAndConditions(): void {
  openUrl(MONEYGRAM_TERMS_AND_CONDITIONS_URL);
}

export function openMoneygramPrivacyPolicy(): void {
  openUrl(MONEYGRAM_PRIVACY_POLICY_URL);
}

export function openMoneygramTermsOfUse(): void {
  openUrl(MONEYGRAM_TERMS_OF_USE_URL);
}

export function openMoneygramTermsAndConditionsUsEs(): void {
  openUrl(MONEYGRAM_TERMS_AND_CONDITIONS_US_ES_URL);
}

export function openMoneygramPrivacyPolicyUsEs(): void {
  openUrl(MONEYGRAM_PRIVACY_POLICY_US_ES_URL);
}
